import request from '@/utils/request'
import axios from 'axios'

const env = process.env.VUE_APP_ENV
const hostMap = {
  development: '/maps/api',
  test: '/api',
  production: '/api'
}

const baseUrl = hostMap[env]

export default {
  getMapDatas(data = {}) {
    return request({ url: `${baseUrl}/media/api/maps`, method: 'get', params: data })
  },
  getMapidToCover(wid) {
    return new Promise(async (resolve, reject) => {
      const resp = await axios.get(`${baseUrl}/media/ex/map`, { params: { wid } })
      if (resp.status === 200 && resp.data && resp.data.root && resp.data.thumb_md5) {
        const url = resp.data.root.replace('http', 'https') + resp.data.thumb_md5 + '.png'
        resolve(url)
      } else {
        reject()
      }
    })
  }
}
